import state from './state.js'
import mutations from './mutation.js'
import actions from './action.js'
// import getters from './getter.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}